module.exports = __webpack_public_path__ + "static/img/mjypc.bde1a0dc.png";